import Vue from 'vue';
import auth from '@/modules/authorization/directives/authorized';
import infiniteScroll from 'vue-infinite-scroll';
import scrollTo from './scrollTo';
import iframeResizer from './iframe-resizer';

Vue.use(infiniteScroll);
Vue.directive(scrollTo.name, scrollTo);
Vue.directive(auth.name, auth);
Vue.directive(iframeResizer.name, iframeResizer);
